import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "@moeindal/base-raiko-panel-components";

export class OtherPaymentsService {

    constructor() {
        this.httpClient = new HttpClient()
    }

    getOtherPaymentsList(page, size, fundID) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/other-payments`,
                {
                    page: page,
                    size: size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewOtherPayment(fundID,
                       title,
                       startDate,
                       endDate,
                       unit,
                       amountPerUnit,
                       expirationDate,
                       description,
                       enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds/${fundID}/other-payments`,
                {
                    "title": title,
                    "startDate": convertPersianDateToUniversalDate(startDate),
                    "endDate": convertPersianDateToUniversalDate(endDate),
                    "unit": unit,
                    "amountPerUnit": amountPerUnit,
                    "hasExpiredTime": expirationDate,
                    "description": description,
                    "enabled": enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    getOtherPaymentBasicInfo(fundID, paymentId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/other-payments/${paymentId}`
            ).then(resolve).catch(reject)
        })
    }

    updateOtherPayment(
        fundID,
        paymentId,
        title,
        startDate,
        endDate,
        unit,
        amountPerUnit,
        expirationDate,
        description,
        enabled
    ) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/other-payments/${paymentId}`,
                {
                    "title": title,
                    "startDate": convertPersianDateToUniversalDate(startDate),
                    "endDate": convertPersianDateToUniversalDate(endDate),
                    "unit": unit,
                    "amountPerUnit": amountPerUnit,
                    "hasExpiredTime": expirationDate,
                    "description": description,
                    "enabled": enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    getBuyRequestsList(fundID, paymentId, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/other-payments/${paymentId}/reservations`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

}